import { Component } from '@verndale/core';

class Navigation extends Component {
  setupDefaults() {
    this.dom = {
      toggleButton: this.el.querySelector('[data-module-navigation="open"]'),
      menu: this.el.querySelector('[data-module-navigation="menu"]'),
      content: this.el.querySelector('[data-module-navigation="content"]'),
      searchLink: this.el.querySelector('[data-module-navigation="close"]'),
      languageDropdownButton: this.el.querySelector(
        '[data-toggle="language-dropdown"]'
      ),
      languageDropdownList: this.el.querySelector('.dropdown-pane'),
      pageContainer: document.querySelector('.page-container'),
      langListItems: this.el.querySelectorAll('.lang-list li a'),
      langAvailableList: this.el.querySelector('.lang-list')
    };

    this.html = document.documentElement;
  }

  addListeners() {
    this.dom.toggleButton.addEventListener('click', this.toggleMenu.bind(this));
    this.dom.searchLink.addEventListener('click', this.toggleMenu.bind(this));
    this.dom.languageDropdownButton.addEventListener(
      'click',
      this.toggleDropdown.bind(this)
    );
    this.dom.langListItems.forEach(item => {
      item.addEventListener('click', this.handleLanguage.bind(this));
    });

    window.addEventListener('load', () => this.html.classList.add('js-loaded'));
  }

  handleLanguage(e) {
    e.preventDefault();
    const { lang } = e.target.dataset;

    if (lang && this.dom.langAvailableList) {
      const url = window.location.href;
      const { langList } = this.dom.langAvailableList.dataset;
      const langListArray = JSON.parse(langList);
      const urlArray = url.split('/');
      const languageIndex = urlArray.findIndex(
        item => langListArray.languages.includes(item) && item
      );
      
      if(languageIndex === -1 || urlArray[languageIndex] === lang) return;
      
      urlArray.splice(languageIndex, 1, lang);
      const newUrl = urlArray.join('/');

      window.location.href = newUrl;
    } else {
      window.location.href = e.target.href;
    }
  }

  open() {
    this.dom.toggleButton.classList.add('js-open');
    this.dom.menu.classList.remove('js-overflow-hidden');
    this.html.classList.add('js-show-navigation');
    this.html.classList.add('js-overflow-hidden');
    if (this.dom.pageContainer)
      this.dom.pageContainer.classList.add('visually-hidden');
  }

  close() {
    this.dom.toggleButton.classList.remove('js-open');
    this.dom.menu.classList.add('js-overflow-hidden');
    this.html.classList.remove('js-show-navigation');
    this.html.classList.remove('js-overflow-hidden');
    if (this.dom.pageContainer)
      this.dom.pageContainer.classList.remove('visually-hidden');
  }

  toggleMenu() {
    if (this.dom.toggleButton.classList.contains('js-open')) {
      this.close();
    } else {
      this.open();
    }
  }

  toggleDropdown() {
    if (this.dom.languageDropdownList.hidden) {
      this.dom.languageDropdownList.removeAttribute('hidden');
      this.dom.languageDropdownButton.ariaExpanded = true;
    } else {
      this.dom.languageDropdownList.setAttribute('hidden', 'true');
      this.dom.languageDropdownButton.ariaExpanded = false;
    }
  }
}

export default Navigation;
